import { render } from "./ConsultaPedidos.vue?vue&type=template&id=557a738e&scoped=true"
import script from "./ConsultaPedidos.vue?vue&type=script&lang=js"
export * from "./ConsultaPedidos.vue?vue&type=script&lang=js"

import "./ConsultaPedidos.vue?vue&type=style&index=0&id=557a738e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557a738e"]])

export default __exports__